
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose, faHome } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess } from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi } from "../helpers/useApi";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";

export const TruckTypes = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const id = watch("id");
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedType, setSelectedType] = useState(0)
  const [passingTon, setPassingTon] = useState([])
  const [truckTypeModel, setTruckTypeModel] = useState(false)


  useEffect(() => {
    if (selectedType > 0 && data.length > 0) {
      const type = data.find(item => item.id === selectedType);
      const passingTon = type ? type.passingTons : [];
      setPassingTon(passingTon);
    }
  }, [selectedType, data]);




  useEffect(() => {
    getData();
  }, [])

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Truck + `/types`);
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData([]);
    } finally {
      setDataLoading(false);
    }
  }

  const handleEdit = async (id) => {
    const item = data.find(x => x.id === id);
    console.log("Data", item)
    setTruckTypeModel(true)
    reset({
      "id": item.id,
      "title": item.name,
      "description": item.description
    })
  }

  const UploadFile = async (file, type) => {
    try {
      const formData = new FormData();
      formData.append("file", file); // append the actual file
      formData.append("type", type); // add type field

      const response = await callApi(API_URL_ENDPOINT.Document + "/upload", {
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status) {
        // sendSuccess(response.message);
        const invoiceKey = response.data?.fileKey || null;
        return invoiceKey;
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(ex.message);
      return null;
    }
  };

  const addTruckType = async (data) => {
    console.log("Data", data)
    try {
      const payload = {
        "id":data.id || 0,
        "name": data.title,
        "description": data.description,
        "icon": null,
      };

      if (data.icon && data.icon.length > 0) {
        const key = await UploadFile(data.icon[0], "icons");
        payload.icon = key;
      }

      const response = await callApi(
        API_URL_ENDPOINT.Truck + "/add-truck-type/",
        {
          method: "POST",
          data: payload,
        }
      );
      if (response.status) {
        setTruckTypeModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
      return null;
    }
  }

  const handleView = (id) => {
    navigate(Routess.TruckTypes.path + `/${id}`)
  }
  


  return (
    <>
      <Model show={truckTypeModel} size={'md'}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">{id != 0 ? "Edit Truck Type" : "Add Truck Type"} </h5>
          <Button variant="" style={{ width: 30, height: 30, outline: 'none' }} className="btn-sm rounded-circle" onClick={() => setTruckTypeModel(false)}><FontAwesomeIcon icon={faClose} /></Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(addTruckType)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox Type="hidden" name={'id'} register={register} errors={errors} watch={watch} />
                  <Textbox Label="Title" name={'title'} Placeholder="Enter Truck Type Title" validationRules={{ required: "Title is required" }} register={register} errors={errors} watch={watch} />
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox Label="Description" name={'description'} Placeholder="Description" register={register} errors={errors} watch={watch} />
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                    <Textbox
                      type="file"
                      accept="image/*"
                      label="Icon"
                      name="icon"
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button type="Button" className="me-2" variant="outline-danger" onClick={() => setTruckTypeModel(false)}>Close</Button>
              <Button type="submit" disabled={isSubmitting} variant="success">Save Changes</Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Truck Types</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Truck Types</h4>
          </div>
        </div>
        <div className="w-25 text-end">
          <Button variant="primary" onClick={() => { setTruckTypeModel(true); reset({ title: '', id: '', description: '' }) }}><FontAwesomeIcon icon={faAdd} /> Add Truck Type</Button>
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="">
          <div className="row">
            {/* <Card border="light" className="shadow-sm mb-4">
                <Card.Body className=""> */}
            {dataLoading ? (
              <div className="text-center my-3">
                <span className="spinner-border text-primary" role="status"></span>
              </div>
            ) : (
              <>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    <div className="col-md-3">
                      <div className="p-2 text-center card mb-3">
                        <img src={item.icon} className="m-auto" height={80}  />
                        <h6 className="text-center">{item.name}</h6>
                        <p className="text-center">7.5 - 43 Ton</p>
                        <div className="d-flex">
                          <Button variant="danger" className="w-100 btn-sm me-1" onClick={() => handleEdit(item.id)}>Edit</Button>
                          <Button variant="primary" className="w-100 btn-sm" onClick={()=>handleView(item.id)}>View</Button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center p-2">No Data Found</p>
                )}
              </>
            )}
            {/* </Card.Body> */}
            {/* </Card> */}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
